import { UserLocale } from '@teetsh/app/src/types/user';
import { EDTPDFSettings } from '@teetsh/app/src/types/edt';

interface Props {
  lng: UserLocale;
  settings: EDTPDFSettings;
  classrooms: string;
  selectedDays?: number[];
  title?: string;
}

export function buildEDTPDFParams({
  lng,
  settings,
  classrooms,
  selectedDays,
  title,
}: Props) {
  const params = new URLSearchParams({
    lng,
    size: (settings.size || 12).toString(),
    displaylength: settings.displaylength ? 'true' : 'false',
    disablevolumehoraire: settings.disableVolumeHoraire ? 'true' : 'false',
    hideclassroombar: settings.disableClassroomBar ? 'true' : 'false',
    disablerelativeslices: settings.disableRelativeSlices ? 'true' : 'false',
    smallbreak: settings.smallBreak ? 'true' : 'false',
    splitMorningAfternoon: settings.splitMorningAfternoon ? 'true' : 'false',
    eventcolor: settings.eventColor,
    bgColor: settings.bgColor || 'white',
    marginTop: (settings.marginTop ?? 0).toString(),
    marginRight: (settings.marginRight ?? 0).toString(),
    marginBottom: (settings.marginBottom ?? 0).toString(),
    marginLeft: (settings.marginLeft ?? 0).toString(),
  });

  if (settings.font) {
    params.set('font', settings.font);
  }

  if (classrooms.length) {
    params.set('classrooms', classrooms);
  }

  if (selectedDays && selectedDays.length > 0) {
    params.set('selectedDays', selectedDays.join(','));
  }

  if (title && title.trim().length > 0) {
    params.set('title', title);
  }

  return params;
}
